import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaICMyL2025 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/260330-Poliza-de-Servicios.pdf`;
  /*const pdfUrl = "/pdf/260330-Poliza-de-Servicios.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2025</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaICMyL2025;
